import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../../firebase.ts";

interface Request {
  email?: string;
  userName?: string;
  applicantName?: string;
  applicantNameKana?: string;
  phoneNumber?: string;
  faxNumber?: string;
  requestDelete?: string;
}

interface Response {
  success: boolean;
  message: string;
}

export const createChangeRequest = async (
  email: string,
  applicantName: string,
  applicantNameKana: string,
  phoneNumber: string,
  faxNumber: string,
  requestDelete: string,
) => {
  const functions = getFirebaseFunctions();
  const createChangeRequest = httpsCallable<Request, Response, object>(
    functions,
    "createChangeRequest",
  );
  const res = await createChangeRequest({
    email,
    applicantName,
    applicantNameKana,
    phoneNumber,
    faxNumber,
    requestDelete,
  });
  return res.data;
};
